module.exports = __webpack_public_path__ + "static/media/esboco8.e65a3898.jpg";